import { Link } from "react-router-dom";
import { Logo } from "./brand/Logo";

export const Footer = () => (
  <footer className="mt-24 border-t border-slate-200 bg-white" data-testid="site-footer">
    <div className="mx-auto grid max-w-7xl gap-8 px-5 py-12 sm:px-8 md:grid-cols-3">
      <div>
        <Logo size={30} textClass="text-lg" />
        <p className="mt-3 text-sm font-semibold text-slate-900" data-testid="footer-tagline">Be the Change.</p>
        <p className="mt-1 max-w-xs text-sm text-slate-600">Helping Canadians discover opportunities to volunteer, support local causes, attend events, and strengthen their communities.</p>
      </div>
      <div className="text-sm text-slate-600">
        <p className="mb-2 font-heading font-semibold text-slate-800">Explore</p>
        <div className="flex flex-col gap-1.5">
          <Link to="/pulse" className="hover:text-sky-800" data-testid="footer-link-pulse">Community Pulse</Link>
          <Link to="/volunteer" className="hover:text-sky-800" data-testid="footer-link-volunteer">Volunteer</Link>
          <Link to="/fundraisers" className="hover:text-sky-800" data-testid="footer-link-fundraisers">Fundraisers</Link>
          <Link to="/events" className="hover:text-sky-800" data-testid="footer-link-events">Events</Link>
          <Link to="/action-index" className="hover:text-sky-800" data-testid="footer-link-action-index">Action Index</Link>
          <Link to="/organizations" className="hover:text-sky-800" data-testid="footer-link-organizations">Organizations</Link>
          <Link to="/organizations" className="hover:text-sky-800" data-testid="footer-link-claim">For organizations: claim your listing</Link>
          <Link to="/my-actions" className="hover:text-sky-800" data-testid="footer-link-my-actions">My Actions</Link>
          <Link to="/news" className="hover:text-sky-800" data-testid="footer-link-sources">Sources & media tools</Link>
          <Link to="/about" className="hover:text-sky-800" data-testid="footer-link-about">About RippleImpact</Link>
        </div>
      </div>
      <p className="text-xs leading-relaxed text-slate-500">
        Headlines belong to their publishers and link to the original articles. RippleImpact is intentionally non-political, non-partisan and non-religious.
        Volunteer listings link to each organization's own site — please confirm details there.
      </p>
    </div>
  </footer>
);
